import { CardProps } from "@/components/Card";
import { CompanyPrograms } from "@/components/Dashboard/CompanyProgramModel";

export const groupData = (data: CompanyPrograms[] = []): Record<string, CompanyPrograms[]> => {
  return data.reduce((program, item) => {
    program[item.ordering] = program[item.ordering] ?? [];
    program[item.ordering]?.push(item);
    return program;
  }, {} as Record<string, CompanyPrograms[]>);
};

export const convertIntoCard = (data: CompanyPrograms[]): CardProps[] => {
  return data.flatMap((item) => {
    if (Array.isArray(item.minioUrl) && item.minioUrl.length > 1) {
      return item.minioUrl.map((imgUrl, i) => ({
        title: Array.isArray(item.title) ? item.title[i] ?? item.title[0] : "",
        excerpt: Array.isArray(item.description)
          ? item.description[i] ?? item.description[0]
          : "",
        imageSrc: imgUrl ?? "/image-placeholder.png",
        imageLeft: item.contentPosition === "Left",
      }));
    } else {
      const singleImage = Array.isArray(item.minioUrl)
        ? item.minioUrl[0]
        : "/image-placeholder.png";

      return [
        {
          title: Array.isArray(item.title) ? item.title[0] : "",
          excerpt: Array.isArray(item.description) ? item.description[0] : "",
          imageSrc: singleImage ?? "/image-placeholder.png",
          imageLeft: item.contentPosition === "Left",
        },
      ];
    }
  });
};
